<div mat-dialog-title fxLayout fxLayoutAlign="space-between center">
    <div fxLayout fxLayoutAlign="start center">
        @if (content.info()?.revisions.length > 1) {
            <button
                mat-mini-fab
                color="accent"
                class="m-y-xs m-r"
                [matMenuTriggerFor]="revisions"
                [attr.aria-label]="'a11y.document.revisions' | translate">
                <mat-icon class="material-symbols-outlined" aria-hidden="true">tab_group</mat-icon>
            </button>
            <mat-menu #revisions="matMenu">
                @for (revision of content.info().revisions; track $index) {
                    <button
                        mat-menu-item
                        (click)="content.selectDocument(revision.entityInstanceId)"
                        [disabled]="revision.entityInstanceId === content.info().entityInstanceId">
                        <span>{{ revision.moduleDocumentNumber }} ({{ revision.revision }})</span>
                    </button>
                }
            </mat-menu>
        }
        <h5 class="cipo--text--ellipsed m-r">
            @if (content.info()) {
                @let parent = content.info().originalModuleDocumentNumber;
                @let revisionMessage = content.info()?.existingDraftMessage;
                {{ currentModule().name }} {{ content.info()?.moduleDocumentNumber }}
                {{ (content.info().isDraftState ? "dm.details.createdBy" : "") | translate: content.info() }}
                @if (parent) {
                    ({{ "dm.details.revisionOf" | translate: { parent } }})
                } @else if (revisionMessage) {
                    <span class="cipo-text--bold-md cipo-text--black-900 p-l-sm">
                        <span class="cipo-bg--warning-lite cipo--border-radius--sm p-a-xs">
                            {{ revisionMessage }}
                        </span>
                    </span>
                }
            } @else if (content.currentDocument()?.params.entityInstanceId === 0) {
                {{ "dm.details.addTitle" | translate: { module: currentModule().name } }}
            } @else {
                {{ currentModule().name }}
            }
        </h5>
        @if (content.info()?.approvalId) {
            <cipo-state name="defaultStatus.AwaitingApproval" [bgColor]="APPROVAL_COLOR" />
        }
    </div>
    <div fxLayout fxLayoutAlign="center center" fxLayoutGap="12px">
        @if (content.autosaveInProgress()) {
            <p>{{ "dm.messages.autosaveInProgress" | translate }}</p>
        }
        @if (content.currentDocument()?.params.screenId) {
            <p class="cipo-text--medium-lg">{{ content.startScreens()[content.currentDocument().params.screenId] }}</p>
        }
        <button
            mat-icon-button
            (click)="content.toggleAiAssistant()"
            [attr.aria-label]="'a11y.header.cipoAI' | translate">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">auto_awesome</mat-icon>
        </button>
        <button
            mat-icon-button
            (click)="fullscreen.toggleFullscreen()"
            [attr.aria-label]="
                (fullscreen.isFullscreen() ? 'a11y.dialog.fullscreenExit' : 'a11y.dialog.fullscreenEnter') | translate
            ">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
                {{ fullscreen.isFullscreen() ? "fullscreen_exit" : "fullscreen" }}
            </mat-icon>
        </button>
        <button
            mat-icon-button
            data-testid="document-details-action-close"
            [matDialogClose]="content.currentDocument()?.info"
            [attr.aria-label]="'a11y.dialog.close' | translate">
            <mat-icon aria-hidden="true">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="p-a-0">
    <cipo-document-details #content [data]="data" (closeRequested)="dialogRef.close($event ?? undefined)" />
</mat-dialog-content>

@if (content.selectedTabIndex() === 0) {
    <mat-dialog-actions>
        <div class="cipo--width--full">
            @if (content.actionsData()) {
                <cipo-document-actions
                    [actions]="content.moreActions()"
                    [data]="content.actionsData()"
                    [transitions]="content.filteredTransitions()"
                    (cancelRequested)="content.discardChanges()"
                    (submitRequested)="content.handleSubmit()"
                    (docNumChanged)="content.docNumChanged($event)"
                    (assignmentChanged)="content.onAssignmentChanged($event)"
                    (actionClicked)="content.handleMoreActions($event)"
                    (actionOptionClicked)="content.handleMoreActionOption($event)"
                    (transitionClicked)="content.handleTransitionClick($event)" />
            }
        </div>
    </mat-dialog-actions>
}
